/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedGetProjectListDto } from '../../models/backend-paginated-get-project-list-dto';

export interface ProjectsProjectsList$Params {
  /**
   * * `drones` - Беспилотники
   * * `biotechnology` - Биотехнологии
   * * `vertical_farms` - Вертикальные фермы
   * * `sensors_iot` - Сенсоры и IoT
   * * `robotics` - Робототехника
   * * `food_tech` - Фудтех
   * * `precision_agriculture` - Точное земледелие
   * * `farm_management_systems` - Системы управления фермами
   * * `marketplaces` - Маркетплейсы
   * * `fishtech` - Фиштех
   */
  category?:
    | (
        | 'biotechnology'
        | 'drones'
        | 'farm_management_systems'
        | 'fishtech'
        | 'food_tech'
        | 'marketplaces'
        | 'precision_agriculture'
        | 'robotics'
        | 'sensors_iot'
        | 'vertical_farms'
      )
    | null;

  /**
   * Фильтр по IRR
   */
  irr_range?: string;

  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;

  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;

  /**
   * Фильтр по периоду окупаемости
   */
  payback_range?: string;

  /**
   * Фильтр по Рейтингу
   */
  rating_range?: string;

  /**
   * A search term.
   */
  search?: string;
}

export function projectsProjectsList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsProjectsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedGetProjectListDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsList.PATH, 'get');
  if (params) {
    rb.query('category', params.category, {});
    rb.query('irr_range', params.irr_range, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('ordering', params.ordering, {});
    rb.query('payback_range', params.payback_range, {});
    rb.query('rating_range', params.rating_range, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedGetProjectListDto>;
    }),
  );
}

projectsProjectsList.PATH = '/api/projects/projects/';
